<!--
 * @Description: 平台品牌 logo（登录/注册/门户首页顶部共用）
-->
<template>
  <div style="min-height: 60px;display: flex;align-items: center;">
    <img style="height:60px;vertical-align:middle;object-fit:contain;" alt="logo" @click="onLogo" src="@/assets/images/logo.png">
    <div style="font-size: 18px;color: #000;margin-left: 20px;white-space: nowrap;font-weight: bold;">金沫旅游</div>
  </div>
</template>
<script>
export default {
  methods: {
    onLogo() {
      this.$router.push("/")
    },
  },
}
</script>
